import { render } from "./MapMaxSetting.vue?vue&type=template&id=198a179a&scoped=true"
import script from "./MapMaxSetting.vue?vue&type=script&lang=js"
export * from "./MapMaxSetting.vue?vue&type=script&lang=js"

import "./MapMaxSetting.vue?vue&type=style&index=0&id=198a179a&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-198a179a"]])

export default __exports__